import { forwardRef } from 'react';
import cx from 'classnames';

import { CustomTypography } from 'src/components/CustomTypography';

import { useStyles } from './useStyles';

interface Props {
  className?: string;
  classes?: Partial<ReturnType<typeof useStyles>>;
  label: string;
  description?: string;
  boldLabel?: boolean;
  grayDescription?: boolean;
  boldDescription?: boolean;
  hideSeparator?: boolean;
}

export const GenerationToolLabel = forwardRef<HTMLParagraphElement, Props>(
  (
    {
      className,
      classes,
      label,
      description = '',
      boldLabel = false,
      grayDescription = false,
      boldDescription = false,
      hideSeparator = false,
      ...restProps
    },
    ref
  ) => {
    const styles = useStyles({ classes });

    return (
      <CustomTypography
        className={cx(styles.root, className, {
          [styles.boldLabel]: boldLabel,
          [styles.grayDescription]: grayDescription,
          [styles.boldDescription]: boldDescription,
        })}
        ref={ref}
        {...restProps}
      >
        <span className={styles.label}>{label}</span>
        {description && (
          <>
            {hideSeparator ? ' ' : <span className={styles.separator}>-</span>}
            <span className={styles.description}>{description}</span>
          </>
        )}
      </CustomTypography>
    );
  }
);
GenerationToolLabel.displayName = 'GenerationToolLabel';
